// extracted by mini-css-extract-plugin
export default {"section":"styles_section__nRHzl","icon":"styles_icon__R1+mj","heading":"styles_heading__rSexT","para":"styles_para__e8U+3","email":"styles_email__r0u-G"};